import { useState } from "react"
import { useNavigate } from "react-router-dom";

/// Manager

export type AgTechNavigationManager = {
    currentRoute: string,
    goTo: (route: string) => void
}

export const DefaultAgTechNavigationManager: AgTechNavigationManager = {
    currentRoute: '/',
    goTo: () => {
        console.error('Attempted to navigate to a page on the default app context');
    }
}

export const useAgTechWebNavigation = (): AgTechNavigationManager => {
    let [currentRoute, setCurrentRoute] = useState('/');
    const navigate = useNavigate();

    return {
        currentRoute,
        goTo: route => {
            navigate(route);
            setCurrentRoute(route);
        }
    }
}
